import React from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
// import { setHomePopUp } from "../signIn/cl_SignInSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setGamePopup } from "../crashGames/cl_CrashSlice";
import { getFromLocalStorage, buildGameLaunchUrl } from "../../services/helper/cl_Helper";



const HomeModal = () => {
  const dispatch = useDispatch();
  const { balanceDetails } = useSelector(
    state => state?.signIn
  )
  const token = getFromLocalStorage("gk");
  const navigate = useNavigate();
  const { gamePopup, gameDetails } = useSelector((state) => state?.crash);

  const handleClose = () => {
    if (gamePopup) {
      if (token) {
        const pendingGame = localStorage.getItem("pendingGame");
        const gameToLaunch = pendingGame ? JSON.parse(pendingGame) : gameDetails;

        localStorage.removeItem("pendingGame");
        const url = buildGameLaunchUrl(gameToLaunch, { gameClose: true });
        window.location.href = url;
        dispatch(setGamePopup(false));
        // dispatch(setHomePopUp(false));
      } else {
        navigate("/signin");
        // dispatch(setHomePopUp(false));
      }
    } else {
      // dispatch(setHomePopUp(false));
    }
  };

  return (
    <React.Fragment>
      <div className="SB-modal SB-exciseDuty SB-modal-fullscreen" id="" style={{ display: "block" }}>
        <div className="SB-modal-dialog">
          <div className="SB-modal-content">
            <div className="SB-modal-close" data-dismiss="modal" onClick={() => handleClose()}>
              <div className="SB-iconSVG" title="close">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#${"icon-close"}`} />
                </svg>
              </div>
            </div>
            {/* <div className="SB-modal-header">
              <div className="SB-modal-title">Excise Duty</div>
            </div> */}
            <div className="SB-modal-body">
              {/* <p>An additional 15% excise duty is due on any stakes placed.</p> */}
              <div className="SB-balanceDetails">
                <div className="SB-balance">Balance - KES {balanceDetails?.real_balance?.result?.balance}</div>
                <div className="SB-unlockedBonus">Unlocked Bonus - {
                  balanceDetails?.bonus_summary?.result?.data
                    ?.unLockedBonus
                }</div>
              </div>
              <p className="SB-info">To use the unlock bonus, the stake should be lesser than or equal to unlock bonus
                amount. <br />
                For more, visit <Link to={"/terms-conditions"}><a href="helpPage.html">T&amp;C</a></Link></p>
              {/* <!-- <div className="SB-btnContainer">
                <button className="btn SB-btnSecondary SB-loyaltyBtn SB-btnMedium">
                  <div className="SB-btnTxt" onclick="window.location.href='loyalty.html'">Ok</div>
                </button>
              </div> --> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HomeModal;
